import { supabase } from '../supabaseClient';

export const datesService = {
  async getDatesData(editionYear) {
    try {
      // Get edition ID
      const { data: edition } = await supabase
        .from('editions')
        .select('id')
        .eq('year', editionYear)
        .single();

      if (!edition) {
        throw new Error(`Edition ${editionYear} not found`);
      }

      // Get main dates data
      const { data: datesData, error: datesDataError } = await supabase
        .from('dates_data')
        .select('*')
        .eq('edition_id', edition.id)
        .single();

      if (datesDataError && datesDataError.code !== 'PGRST116') {
      }

      // Get key dates
      const { data: keyDates } = await supabase
        .from('dates_key_dates')
        .select('*')
        .eq('edition_id', edition.id)
        .order('display_order');

      return {
        datesHeader: {
          title: datesData?.dates_header_title || 'Dates Importantes'
        },
        countdownInfo: {
          targetDate: datesData?.countdown_target_date || '',
          targetTime: datesData?.countdown_target_time || '09:00',
          isActive: datesData?.countdown_is_active !== false
        },
        congressMainInfo: {
          dateRange: datesData?.congress_date_range || '',
          location: datesData?.congress_location || '',
          subLocation: datesData?.congress_sub_location || ''
        },
        extensionInfo: {
          title: datesData?.extension_title || '',
          deadline: datesData?.extension_deadline || '',
          description1: datesData?.extension_description1 || '',
          description2: datesData?.extension_description2 || ''
        },
        ctaInfo: {
          text: datesData?.cta_text || '',
          publicationNote: datesData?.cta_publication_note || ''
        },
        keyDates: (keyDates || []).map(keyDate => ({
          id: keyDate.id,
          title: keyDate.title,
          date: keyDate.date,
          icon: keyDate.icon,
          displayOrder: keyDate.display_order
        }))
      };
    } catch (error) {
      throw error;
    }
  },

  async updateDatesPageData(datesData, editionYear) {
    try {
      // Get edition ID
      const { data: edition } = await supabase
        .from('editions')
        .select('id')
        .eq('year', editionYear)
        .single();

      if (!edition) {
        throw new Error(`Edition ${editionYear} not found`);
      }

      const updateData = {
        edition_id: edition.id,
        dates_header_title: datesData.datesHeader?.title || 'Dates Importantes',
        congress_date_range: datesData.congressMainInfo?.dateRange || '',
        congress_location: datesData.congressMainInfo?.location || '',
        congress_sub_location: datesData.congressMainInfo?.subLocation || '',
        extension_title: datesData.extensionInfo?.title || '',
        extension_deadline: datesData.extensionInfo?.deadline || '',
        extension_description1: datesData.extensionInfo?.description1 || '',
        extension_description2: datesData.extensionInfo?.description2 || '',
        cta_text: datesData.ctaInfo?.text || '',
        cta_publication_note: datesData.ctaInfo?.publicationNote || '',
        countdown_target_date: datesData.countdownInfo?.targetDate || null,
        countdown_target_time: datesData.countdownInfo?.targetTime || '09:00',
        countdown_is_active: datesData.countdownInfo?.isActive !== false,
        updated_at: new Date().toISOString()
      };

      // Try to update existing record first
      const { data: existingData } = await supabase
        .from('dates_data')
        .select('id')
        .eq('edition_id', edition.id)
        .single();

      if (existingData) {
        // Update existing record
        const { data, error } = await supabase
          .from('dates_data')
          .update(updateData)
          .eq('id', existingData.id)
          .select()
          .single();

        if (error) throw error;
        return data;
      } else {
        // Insert new record
        const { data, error } = await supabase
          .from('dates_data')
          .insert([updateData])
          .select()
          .single();

        if (error) throw error;
        return data;
      }
    } catch (error) {
      throw error;
    }
  },

  async addKeyDate(keyDateData, editionYear) {
    try {
      // Get edition ID
      const { data: edition } = await supabase
        .from('editions')
        .select('id')
        .eq('year', editionYear)
        .single();

      if (!edition) {
        throw new Error(`Edition ${editionYear} not found`);
      }

      const insertData = {
        edition_id: edition.id,
        title: keyDateData.title,
        date: keyDateData.date,
        icon: keyDateData.icon || 'HiOutlineDocumentText',
        display_order: keyDateData.displayOrder || 0
      };

      const { data, error } = await supabase
        .from('dates_key_dates')
        .insert([insertData])
        .select()
        .single();

      if (error) throw error;
      return data;
    } catch (error) {
      throw error;
    }
  },

  async updateKeyDate(keyDateId, keyDateData) {
    try {
      const updateData = {
        title: keyDateData.title,
        date: keyDateData.date,
        icon: keyDateData.icon || 'HiOutlineDocumentText',
        display_order: keyDateData.displayOrder || 0,
        updated_at: new Date().toISOString()
      };

      const { data, error } = await supabase
        .from('dates_key_dates')
        .update(updateData)
        .eq('id', keyDateId)
        .select()
        .single();

      if (error) throw error;
      return data;
    } catch (error) {
      throw error;
    }
  },

  async deleteKeyDate(keyDateId) {
    try {
      const { error } = await supabase
        .from('dates_key_dates')
        .delete()
        .eq('id', keyDateId);

      if (error) throw error;
    } catch (error) {
      throw error;
    }
  }
};
